import EventWizardPage from './EventWizardPage'

const { EventInfo,EventDetails,LaneConditions,Setup,Participants,EventTemplate } = EventWizardPage

export default  [
    { 'text': 'Event Information', 'isActive':true, 'isDone':false, 'step':EventInfo },
    { 'text': 'Event Details', 'isActive':false, 'isDone':false , 'step':EventDetails  },
    { 'text': 'Lane Conditions',  'isActive':false, 'isDone':false, 'step':LaneConditions  },
    { 'text': 'Setup',  'isActive':false, 'isDone':false, 'step':Setup  },
    { 'text': 'Participants',  'isActive':false, 'isDone':false, 'step':Participants },
    { 'text': 'Setup Complete', 'isActive':false, 'isDone':false , 'step':EventTemplate }
] 


// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/Constants/EventWizardStepDefinition.js